import React from 'react'
import moment from 'moment'
import styled, { keyframes } from 'styled-components'
import { media } from 'src/styles/styled-components'
import routesConfig from 'src/routes.config'
import { Link } from 'gatsby'

// import ArHeading from 'src/components/typography/ArHeading'
import ArMonoTag from 'src/components/typography/ArMonoTag'

const rotate = keyframes`
  from {
    transform: translateY(20px);
    opacity: .5;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
`

const StyledContainer = styled(Link)`
  animation: ${ rotate } .15s ease-out;
  animation-delay: ${ ({ index }) => (index) / 20 }s;
  animation-fill-mode: forwards;
  border-top: 2px solid rgba(168,168,168,0.1);
  opacity: 0;
  padding: 20px 0;
  transform: translateY(20px);
  width: 100%;
  ${ media.tablet`
    display: flex;
    flex-direction: row;
    align-items: center;
  ` }
  :last-of-type {
    border-bottom: 2px solid rgba(168,168,168,0.1);
  }
`

const StyledHeading = styled.h2`
  font-size: 1.8rem;
  line-height: 1.55;
  ${ media.tablet`
    margin-left: 30px;
  ` }
  ${ media.desktop`
    font-size: 2.8rem;
    line-height: 1.6;
    font-weight: ${ p => p.theme.fontWeight.primary.Light };
  ` }
`

const ArBlogPost = ({ data, itemIndex }) => {
  const date = moment(data.date).format('DD/MM/YY')
  return (
    <StyledContainer to={routesConfig.company.blog({ slug: data.slug })} target="_blank" index={itemIndex}>
      <ArMonoTag>{date}</ArMonoTag>
      <StyledHeading>{data.title}</StyledHeading>
    </StyledContainer>
  )
}

export default ArBlogPost
